import { useContext, useState, useEffect, useRef } from "react"
import { Box, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import OneModal from "../../../Components/OneModal/OneModal"
import { showNotify } from "../../../Utils/Utils"
import { WebSocketContext } from "../../../Providers/WebSocket/WebSocketContext"
import OneInput from "../../../Components/OneInput/OneInput"
import OneDatePicker from "../../../Components/OneDatePicker/OneDatePicker"
import OneTextArea from "../../../Components/OneTextArea/OneTextArea"
import Video from '../../../Components/Video/Video'

import { FlexRowBeetwen, GridAudios, GridDireita, GridFotos, GridVideos, BlackBox, TitleListPlayer, BoxGridPlayers, inputGroupSx } from "./sxVisualizacaoEvento"
import LineVideoPlay from "./LineVideoPlay"
import LineFotoPlay from "./LineFotoPlay"
import LineLigacaoPlay from "./LineLigacaoPlay"
import moment from 'moment'
import AudioModal from "../../../Components/AudioModal/AudioModal"

const VisualizacaoEvento = ({ openEvento, setOpenEvento, idToView, setIdToView, naoOuvirAudio = false }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [initialData, setInitialData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [openVideo, setOpenVideo] = useState(false)
    const video = useRef()
    const [openAudio, setOpenAudio] = useState(false)
    const [audioLink, setAudioLink] = useState(false)

    const handleOpenVideo = () => {
        setOpenVideo(current => !current)
    }

    const handleOpenAudio = (link) => {
        setAudioLink(link)
        setOpenAudio(current => !current)
    }

    const getDadosIniciais = (msg) => {
        if (msg.data.status) {
            setInitialData(msg.data.evento)
            setLoading(false)
        } else {
            showNotify(msg.message)
            setOpenEvento(false)
        }
    }

    useEffect(() => {
        addRoute("getEventoTratado", getDadosIniciais)
        sendWs("getEventoTratado", { id: idToView })
    }, [])

    const campoEntrada = (evento) => {
        if (["OENE", "OENR"].includes(evento.evento)) {
            return evento.nome_evento
        } else if (["ORAM"].includes(evento.evento)) {
            if (evento.nome_entrada !== null && evento.nome_entrada !== "") {
                return evento.nome_entrada + " - Ramal: " + evento.auxiliar
            } else {
                return "Ramal: " + evento.auxiliar
            }
        } else {
            return evento.nome_entrada
        }
    }

    return (
        <OneModal
            open={openEvento}
            setOpen={setOpenEvento}
            loading={loading}
            titleText="Evento"
            fullWidth={true}
            maxWidth={'md'}
        >
            {openVideo &&
                <Video
                    open={openVideo}
                    setOpen={handleOpenVideo}
                    cameraId={video.current.id}
                    title={video.current.nome_exibicao}
                    eventId={idToView}
                />
            }
            {openAudio &&
                <AudioModal
                    open={openAudio}
                    setOpen={setOpenAudio}
                    title={"Ligação"}
                    eventId={idToView}
                    link={audioLink}
                />
            }
            {/* grid principal */}
            <Grid xs={12} container>
                {/* lado esquerdo */}
                <Grid
                    xs={9}
                    rowSpacing={1}
                    columnSpacing={1}
                    container
                    gap={0.5}
                >

                    <Grid xs={12} sx={inputGroupSx}>
                        <Grid xs={3} sm={3} lg={2}>
                            <Typography fontSize="13px" fontWeight='400' >Cond/Empresa: </Typography>
                        </Grid>
                        <Grid xs={8} sm xl>
                            <OneInput style={{ backgroundColor: 'white' }} defaultValue={initialData ? `${initialData?.id_central} - ${initialData.nome_cond}` : ""} readOnly={true}/>
                        </Grid>
                    </Grid>

                    <Grid xs={12} sx={inputGroupSx}>
                        <Grid xs={3} sm={3} lg={2}>
                            <Typography fontSize="13px" fontWeight='400' >Evento: </Typography>
                        </Grid>
                        <Grid xs={8} sm lg>
                            <OneInput style={{ backgroundColor: 'white' }} defaultValue={initialData ? `${initialData?.evento} - ${initialData.descricao_evento}` : ""} readOnly={true}/>
                        </Grid>
                    </Grid>

                    <Grid xs={12} sx={inputGroupSx}>
                        <Grid xs={3} sm={3} lg={2}>
                            <Typography fontSize="13px" fontWeight='400' >Morador: </Typography>
                        </Grid>
                        <Grid xs={8} sm lg>
                            <OneInput style={{ backgroundColor: 'white' }} defaultValue={initialData?.morador || (initialData?.nome_evento || "Sem nome")} readOnly={true} />
                        </Grid>
                    </Grid>

                    <Grid xs={12} sx={inputGroupSx}>
                        <Grid xs={3} sm={3} lg={2}>
                            <Typography fontSize="13px" fontWeight='400' >Entrada/Acesso: </Typography>
                        </Grid>
                        <Grid xs={8} sm lg>
                            <OneInput style={{ backgroundColor: 'white' }} defaultValue={initialData?.evento && campoEntrada(initialData)} readOnly={true}/>
                        </Grid>
                    </Grid>

                    {/* here */}
                    <Grid xs={12} sx={inputGroupSx} flexWrap='wrap'>
                        <Grid xs={12} lg={6} sx={inputGroupSx}>
                            <Grid xs={3} lg={4} >
                                <Typography fontSize="13px" fontWeight='400' >Chegada: </Typography>
                            </Grid>
                            <Grid xs={9} lg={8}>
                                <OneDatePicker style={{ backgroundColor: 'white' }} defaultValue={initialData?.data_chegada || ""} readOnly={true} disabled={true}/>
                            </Grid>
                        </Grid>

                        <Grid xs={12} lg={6} sx={inputGroupSx}>
                            <Grid xs={3} lg={4}>
                                <Typography fontSize="13px" fontWeight='400' >Atendido: </Typography>
                            </Grid>
                            <Grid xs={9} lg={8}>
                                <OneDatePicker style={{ backgroundColor: 'white' }} defaultValue={initialData?.data_tratando || ""} readOnly={true} disabled={true}/>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid xs={12} sx={inputGroupSx} flexWrap='wrap'>
                        <Grid xs={12} lg={6} sx={inputGroupSx}>
                            <Grid xs={3} lg={4}>
                                <Typography fontSize="13px" fontWeight='400' >Conclusão: </Typography>
                            </Grid>
                            <Grid xs={9} lg={8}>
                                <OneDatePicker style={{ backgroundColor: 'white' }} defaultValue={initialData?.data_fechamento || ""} readOnly={true} disabled={true}/>
                            </Grid>
                        </Grid>
                        <Grid xs={12} lg={6} sx={inputGroupSx}>
                            <Grid xs={3} lg={4}>
                                <Typography fontSize="13px" fontWeight='400' >Usuário: </Typography>
                            </Grid>
                            <Grid xs={9} lg={8}>
                                <OneInput style={{ backgroundColor: 'white' }} defaultValue={initialData?.nome_operador || "Sem tratar"} readOnly={true} disabled={true}/>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid xs={12} sx={inputGroupSx}>
                        <Grid xs={3} sm={3} lg={2}>
                            <Typography fontSize="13px" fontWeight='400' >Obs Fechamento: </Typography>
                        </Grid>
                        <Grid xs={8} sm lg>
                            <OneTextArea style={{ backgroundColor: 'white', height: '80px' }} defaultValue={initialData?.obs_fechamento || "Sem Obs"} readOnly={true}/>
                        </Grid>
                    </Grid>

                    <Grid xs={12} sx={inputGroupSx}>
                        <Grid xs={3} sm={3} lg={2}>
                            <Typography fontSize="13px" fontWeight='400' >Log Geral: </Typography>
                        </Grid>
                        <Grid xs={8} sm lg>
                            <OneTextArea style={{ backgroundColor: 'white', height: '80px' }} defaultValue={initialData?.historico || "Sem Obs"} readOnly={true}/>
                        </Grid>
                    </Grid>

                </Grid>
                {/* lado direito */}
                <Grid
                    xs={3}
                    rowSpacing={0}
                    columnSpacing={1}
                    gap={0.5}
                    sx={GridDireita}
                >
                    <Grid xs={12} sx={GridVideos}>
                        <Box component='div' sx={BoxGridPlayers}>
                            <Box component='span' sx={TitleListPlayer}>Videos</Box>
                            <Box component='div' sx={{ ...FlexRowBeetwen, ...BlackBox }}>
                                {initialData && initialData.cameras &&
                                    initialData.cameras.map(camera => {
                                        return (
                                            <LineVideoPlay title={camera.nome_exibicao} handleOpenVideo={() => { handleOpenVideo(); video.current = { ...camera } }}/>
                                        )
                                    })
                                }
                            </Box>
                        </Box>
                    </Grid>

                    <Grid xs={12} sx={GridFotos}>
                        <Box component='div' sx={BoxGridPlayers}>
                            <Box component='span' sx={TitleListPlayer}>Fotos</Box>
                            <Box component='div' sx={{ ...FlexRowBeetwen, ...BlackBox }}>
                                {initialData && initialData.imagens &&
                                    initialData.imagens.map((imagem, i) => {
                                        return (
                                            <LineFotoPlay title={`Imagem ${i}`} imageName={imagem} eventId={initialData.id}/>
                                        )
                                    })
                                }
                            </Box>
                        </Box>
                    </Grid>

                    <Grid xs={12} sx={GridAudios}>
                        <Box component='div' sx={BoxGridPlayers}>
                            <Box component='span' sx={TitleListPlayer}>Audios</Box>
                            <Box component='div' sx={{ ...FlexRowBeetwen, ...BlackBox }}>
                                {initialData && initialData.ligacoes &&
                                    initialData.ligacoes.map((lig, i) => {
                                        let diff = moment.utc(lig.dt_finalizado).diff(moment(lig.dt_inicio), 'seconds')
                                        diff = (diff > 60 ? `${moment.utc(lig.dt_finalizado).diff(moment(lig.dt_inicio), 'minutes')} m.` : `${diff} s.`) // se tiver mais de 1 mim, mostra em minutos
                                        return (
                                            <LineLigacaoPlay
                                                title={`H: ${moment.utc(lig.dt_inicio).format('HH:mm:ss')} | Tmp: ${diff}`}
                                                ligacao={lig}
                                                handleOpenAudio={handleOpenAudio}
                                            />
                                        )
                                    })
                                }
                            </Box>
                        </Box>
                    </Grid>

                </Grid>
            </Grid>
        </OneModal>
    )
}

export default VisualizacaoEvento
